export class JsonSerializable {

  id: string;
  
  constructor() {
    this.id = null;
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {
        if(Array.isArray(jsonObj[propName])){
          for (let i in jsonObj[propName]) {
            if(typeof this[propName].fromJSON === 'function') {
              this[propName][i].fromJSON(jsonObj[propName][i]);
            } else {
              this[propName][i] = jsonObj[propName][i];
            }
          }
        } else {
          if(jsonObj[propName] instanceof Object){
            if(typeof this[propName].fromJSON === 'function') {
              this[propName].fromJSON(jsonObj[propName]);
            } else {
              this[propName] = jsonObj[propName];
            }
          }
        }
        this[propName] = jsonObj[propName];
      }
    }
  }

  inArray(list) {
    if(list){
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id == this.id) {
            return true;
        }
      }
    }

    return false;
  }

  removeFromArray(list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].id == this.id) {
        list.splice(i, 1);
      }
    }

    return false;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/jsonSerializable.ts